<template>
  <div>
    <label class="font-lato mb-2 block text-lg text-ng800" :for="props.name">{{ props.label }}</label>
    <div class="relative flex flex-col">
      <input
        class="peer block min-h-[46px] w-full rounded-sm border border-ng10 bg-transparent px-3 py-3 pl-[69px] text-base leading-[1.2] text-ng800 transition duration-200 ease-out focus:outline-none focus:ring-2 focus-visible:ring-ng300 laptop:min-h-[56px] laptop:py-[17px]"
        :type="props.type"
        :id="props.name"
        :name="props.name"
        v-model.trim="value"
        required
        placeholder=" "
        :pattern="pattern"
        @blur="validate"
        @input="validate"
        ref="input"
        :class="{
          'invalid:ring-1 invalid:ring-[#b42c2c] focus:ring-2  focus:invalid:border-[#b42c2c] focus-visible:!ring-[#b42c2c]':
            !validInput,
          'focus:valid:border-[#8AA678] focus:valid:ring-2  focus:valid:ring-[#8AA678]': validInput,
        }"
      />
      <span
        class="absolute left-4 top-1/2 flex -translate-y-1/2 items-center justify-center text-ng10 transition duration-200 ease-out"
        :class="{
          'text-[#b42c2c]': !validInput,
          'peer-focus:peer-valid:text-[#8AA678] peer-focus-visible:text-ng300': validInput,
        }"
      >
        <Icon :name="icon" size="28" class="" />
      </span>
    </div>
    <span
      class="mt-2 block min-h-[18px] text-xs text-[#b42c2c]"
      :class="{
        'opacity-0': validInput,
        'opacity-1': !validInput,
      }"
    >
      {{ errorMessages[props.name] }}
    </span>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  type: string;
  name: string;
  icon: string;
  label: string;
  value: string;
}>();

const { t: $t } = useI18n();
const emit = defineEmits(["update:value", "validate:value"]);
const value = computed({
  get: () => {
    return props.value;
  },
  set: (value) => {
    emit("update:value", value);
  },
});

const input = ref<HTMLInputElement | null>(null);

const errorMessages = computed(() => {
  return {
    email: `${value.value !== "" ? `${value.value} ${$t("enter-valid-email")}.` : `${$t("enter-email")}.`}`,
    fname: `${$t("enter-name")}`,
    company: `${$t("enter-company")}`,
  };
});

const validInput = ref(true);

function validate() {
  if (input.value) {
    if (input.value.validity.valid) {
      validInput.value = true;
    } else {
      validInput.value = false;
    }
  }
}

defineExpose({
  validate,
});

const pattern = computed(() => {
  switch (props.type) {
    case "email":
      return "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
    default:
      return undefined;
  }
});
</script>
